/**
 * scroll-progress.js
 * Drives the #scroll-progress-bar width based on page scroll depth.
 * ~25 lines. Zero dependencies. RAF-throttled (one update per frame max).
 */
(function () {
  'use strict';

  var bar = document.getElementById('scroll-progress-bar');
  if (!bar) return;

  var rafId = null;

  function update() {
    var scrollTop = window.scrollY || document.documentElement.scrollTop;
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;

    var pct = scrollable > 0
      ? Math.min(100, (scrollTop / scrollable) * 100)
      : 0;

    bar.style.width = pct + '%';
    bar.setAttribute('aria-valuenow', Math.round(pct));
    rafId = null;
  }

  // passive: true — never blocks scrolling
  window.addEventListener('scroll', function () {
    if (rafId) return;
    rafId = requestAnimationFrame(update);
  }, { passive: true });

  // Run once on load in case the page is pre-scrolled (e.g. browser restore)
  update();

}());
